import React, {useState, useEffect} from "react";

/**
 * Компонент TimerTemplate отображает таймер, который отсчитывает время до заданного времени.
 * Если оставшееся время равно 0, отображается текст по умолчанию.
 *
 * @param {number} endTimeSeconds Время окончания таймера в секундах.
 * @param {string} textTemplateTimer Шаблон текста для отображения таймера, должен содержать "${time}".
 * @param {string} defaultText Текст, который отображается, когда таймер достигает 0 секунд.
 * @return JSX.Element Шаблонный текст с таймером или текст по умолчанию.
 */

const TimerTemplate = ({endTimeSeconds, textTemplateTimer, defaultText}) => {
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        const currentTime = Date.now() / 1000;
        let timer;
        if (endTimeSeconds > currentTime) {
            timer = setInterval(() => {
                const currentTime = Date.now() / 1000;
                const duration = Math.floor(endTimeSeconds - currentTime);

                if (duration > 0) {
                    setSeconds(duration);
                } else {
                    setSeconds(0);
                    clearInterval(timer);
                }
            }, 1000);
        }

        return () => {
            clearInterval(timer);
        };
    }, [endTimeSeconds]);

    if (seconds === 0) {
        return <span>{defaultText}</span>;
    }

    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const time = `${mins < 10 ? '0' + mins : mins}:${secs < 10 ? '0' + secs : secs}`;
    const text = textTemplateTimer.replace('${time}', time);

    return (
        <span>{text}</span>
    );
};

export default TimerTemplate;
